import type {
  FetchNotificationsDefaultAction,
  FetchNotificationsFulfilledAction,
  FetchNotificationsRejectedAction,
  MarkAllNotificationDoneDefaultAction,
  MarkAllNotificationDoneFulfilledAction,
  MarkAllNotificationDoneRejectedAction,
  RemoveNotificationDefaultAction,
  RemoveNotificationFulfilledAction,
  RemoveNotificationRejectedAction,
  UpdateNotificationDefaultAction,
  UpdateNotificationFulfilledAction,
  UpdateNotificationRejectedAction,
} from "domains/notifications/actionTypes";
import { NotificationActionType } from "domains/notifications/actionTypes";
import type { UpdateNotificationMeta } from "domains/notifications/types";

export const fetchNotifications = ({ offset = 0 }): FetchNotificationsDefaultAction => ({
  type: NotificationActionType.FETCH,
  meta: { offset },
});

export const fetchNotificationsSuccess = (
  meta: { offset: number },
  payload: FetchNotificationsFulfilledAction["payload"],
): FetchNotificationsFulfilledAction => ({
  type: NotificationActionType.FETCH_FULFILLED,
  meta,
  payload,
});

export const fetchNotificationsFailure = (
  meta: FetchNotificationsRejectedAction["meta"],
): FetchNotificationsRejectedAction => ({
  meta,
  type: NotificationActionType.FETCH_REJECTED,
});

export const updateNotification = (meta: UpdateNotificationMeta): UpdateNotificationDefaultAction => ({
  type: NotificationActionType.UPDATE,
  meta,
});

export const updateNotificationSuccess = (meta: UpdateNotificationMeta): UpdateNotificationFulfilledAction => ({
  type: NotificationActionType.UPDATE_FULFILLED,
  meta,
});

export const updateNotificationFailure = (
  meta: UpdateNotificationRejectedAction["meta"],
): UpdateNotificationRejectedAction => ({
  type: NotificationActionType.UPDATE_REJECTED,
  meta,
});

export const removeNotification = (id: string): RemoveNotificationDefaultAction => ({
  type: NotificationActionType.REMOVE,
  meta: { id },
});

export const removeNotificationSuccess = (id: string): RemoveNotificationFulfilledAction => ({
  type: NotificationActionType.REMOVE_FULFILLED,
  meta: { id },
});

export const removeNotificationFailure = (
  meta: RemoveNotificationRejectedAction["meta"],
): RemoveNotificationRejectedAction => ({
  meta,
  type: NotificationActionType.REMOVE_REJECTED,
});

export const markAllNotificationDone = (): MarkAllNotificationDoneDefaultAction => ({
  type: NotificationActionType.MARK_ALL_DONE,
});

export const markAllNotificationDoneSuccess = (): MarkAllNotificationDoneFulfilledAction => ({
  type: NotificationActionType.MARK_ALL_DONE_FULFILLED,
});

export const markAllNotificationDoneFailure = (
  meta: MarkAllNotificationDoneRejectedAction["meta"],
): MarkAllNotificationDoneRejectedAction => ({
  meta,
  type: NotificationActionType.MARK_ALL_DONE_REJECTED,
});
